/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { object, string, bool, func } from 'prop-types';  // eslint-disable-line
import { Link } from 'react-router-dom';

import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    modalContent: {
        position: 'absolute',
        width: '80%',
        backgroundColor: theme.palette.white,
        boxShadow: theme.shadows[5],
        padding: 0, // theme.spacing.unit * 2,
        textAlign: 'center',
        borderRadius: '8px',
        '&:focus': {
            outline: `solid 0px ${theme.cta1}`,
            boxShadow: `0 0 10px ${theme.cta1}`,
        },
    },
    descModal: {
        color: theme.cta1,
        marginTop: '0px',
    },
    closeIconButton: {
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        padding: '2px',
    },
    closeIcon: {
        backgroundColor: theme.cta1,
        borderRadius: '100%',
        color: theme.palette.white,
        fontSize: '24px',
        padding: '1px',
    },
    titleH2: {
        backgroundColor: theme.cta1,
        color: theme.palette.white,
        margin: '0',
        padding: '6px 10px',
        fontSize: '16px',
        fontWeight: '400',
        borderRadius: '8px 8px 0 0',
    },
    info: {
        margin: '5px 0 0',
        padding: '10px',
        textAlign: 'justify',
    },
    infoHome: {
        padding: '5px 10px',

    },
    linkHome: {
        color: theme.brown1,
        margin: '0 4px',
    },
});


function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class ErrorModal extends PureComponent {
    getErrorMessage = (errorKey, brandCode, classes) => {
        let errorMessage = '';
        let showHomeLink = false;

        switch (errorKey) {
            case '_ERR_PROD_NOT_EXISTING':
                errorMessage = 'We are sorry, but this product is no longer available. Please select another product.';
                showHomeLink = true;
                break;
            case '_ERR_PRODUCT_OUT_OF_STOCK':
                errorMessage = 'We are sorry, but this product is currently out of stock. Please select another product.';
                showHomeLink = true;
                break;
            case '_ERR_PASSPORT_ITEM_ALREADY_IN_CART':
                errorMessage = 'Your cart already contains a passport membership.';
                break;
            default:
                errorMessage = 'There was an unexpected problem.';
                break;
        }

        return (
            <div>
                <h2 className={classes.titleH2}>Information</h2>
                <p className={classes.info}>
                    {errorMessage}
                </p>
                {
                    showHomeLink
                    && (
                        <p className={classes.infoHome}>
                            Click
                            <Link className={classes.linkHome} to={`/${brandCode}-HomePage`}>here</Link>
                            to return to our Home page.
                        </p>
                    )
                }
            </div>
        );
    }

    render() {
        const {
            classes, errorMessage, brandCode, clickCloseModal, isOpenModal,
        } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={isOpenModal}
                onClose={clickCloseModal}
            >
                <div style={getModalStyle()} className={classes.modalContent}>
                    <IconButton
                        classes={{
                            root: classes.closeIconButton,
                        }}
                        aria-label="Close"
                        onClick={clickCloseModal}
                    >
                        <CloseIcon className={classes.closeIcon} style={{ maxWidth: '24px' }} />
                    </IconButton>
                    <div id="modal-description" className={classes.descModal}>
                        { errorMessage && errorMessage.errorKey && this.getErrorMessage(errorMessage.errorKey, brandCode, classes)}
                    </div>
                </div>
            </Modal>
        );
    }
}

ErrorModal.propTypes = {
    classes: object.isRequired,  // added by withStyles HOC
    errorMessage: object,
    brandCode: string,
    clickCloseModal: func.isRequired,
    isOpenModal: bool.isRequired,
};

ErrorModal.defaultProps = {
    errorMessage: {}, // errorKey: _ERR_PRODUCT_OUT_OF_STOCK - _ERR_PROD_NOT_EXISTING - _ERR_PASSPORT_ITEM_ALREADY_IN_CART
    brandCode: '',
};

export default withStyles(styles)(ErrorModal);
